import React, { useState, useEffect, useRef } from 'react'
import { ProjectData } from '../Constants'
import EasyShopProject from '../../images/easyShopHomepage.png'
import ChatterLink from '../../images/message-page.png'
import CleanPRImage from '../../images/cleanPR - demo.png'
import {
  ProjectsWrapper,
  ProjectsHeader,
  Project,
  ProjectCard,
  ProjectImageWrapper,
  ProjectImage,
  ProjectInfo,
  ProjectTitle,
  SkillsContainer,
  SkillTag,
  ProjectButtonContainer,
  ProjectGithubButton
} from './styles/Project.styles'

// Custom SVG components for missing ic

function Projects() {
  const projectRef = useRef([])
  const [visibleIndex, setVisibleIdex] = useState([])
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 1025);
    };

    window.addEventListener('resize', handleResize);

    // Call handler once to set initial state correctly
    handleResize();

    // Cleanup on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const index = projectRef.current.indexOf(entry.target);
          if (entry.isIntersecting && !visibleIndex.includes(index)) {
            setVisibleIdex(prev => [...prev, index]);
          };
        });
      }, { threshold: 0.3 });

      const current = projectRef.current
      current.forEach(ref => {
        if (ref) observer.observe(ref);
      });

      return () => {
        current.forEach(ref => {
          if (ref) observer.unobserve(ref);
        });
      };
    }
  )

  const ProjectImages = {
    'Easy-shop-E-commerce': EasyShopProject,
    'ChatterLink - chat app': ChatterLink,
    'CleanPR - AI Code Reviewer': CleanPRImage
  }

  return (
    <ProjectsWrapper id="projects" >
      <ProjectsHeader>Projects</ProjectsHeader>
        <Project>
          {ProjectData.map((project, projectIndex) => {

            return (
              <ProjectCard 
                ref={el => (projectRef.current[projectIndex] = el)}
                key={projectIndex}
                $isVisible={visibleIndex.includes(projectIndex)}
                >
                <ProjectImageWrapper>
                  <ProjectImage
                    src={ProjectImages[project.name]}
                  />

                </ProjectImageWrapper>

                <ProjectInfo>
                  <ProjectTitle>{project.name}</ProjectTitle>

                  <SkillsContainer>
                    {project.skills.map((skill, skillIndex) => {
                      return (
                        <SkillTag key={skillIndex} isMobile={isMobile}>
                          <span className="skill-text">{skill}</span>
                        </SkillTag>
                      )
                    })}
                  </SkillsContainer>
                </ProjectInfo>

                <ProjectButtonContainer>
                  <ProjectGithubButton
                    onClick={() => window.open(project.github, '_blank')}
                  >
                    <i className="bi bi-github" style={{ fontSize: isMobile ? '2rem' : '1.2rem' }}></i>
                    {!isMobile && 'GitHub'}
                  </ProjectGithubButton>

                </ProjectButtonContainer>
              </ProjectCard>
            )
          })}
        </Project>
    </ProjectsWrapper>
  )
}

export default Projects